import React from "react";

interface Props {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  [key: string]: any;
}

export function VariableInput({ label, value, onChange, ...rest }: Props) {
  return (
    <div className="flex items-center gap-[24px]">
      <p className="m-0 w-[150px] text-[20px] font-bold">{label}</p>
      <input
        value={value}
        onChange={onChange}
        {...rest}
        className="h-[54px] w-[calc(100%-150px)] rounded-[4px] border-[1px] border-gray-1 bg-[#fafafa] px-[24px] py-[16px] text-M3 outline-none placeholder:text-[#c6c6c6] read-only:text-gray-3 focus:border-gray-5 focus:ring-0 read-only:focus:border-gray-1"
      />
    </div>
  );
}
